import { createContext, MutableRefObject } from 'react';

interface BuilderStepNavigationContextValue {
  requestNavigationToStep: (targetStepIndex: number) => void;
  registerNavigationHandler: (handler: ((targetStepIndex: number) => Promise<void>) | null) => void;
  pendingNavigationTargetRef: MutableRefObject<number | null>;
  clearPendingNavigationTarget: () => void;
}

export const BuilderStepNavigationContext = createContext<BuilderStepNavigationContextValue | undefined>(undefined);
